import { saveAs } from 'file-saver';

export const CSV_COLUMNS = [
  'controlId',
  'title',
  'description',
  'category',
  'subcategory',
  'priority',
  'documentationUrl',
];

export const REQUIRED_COLUMNS = ['controlId', 'title'];

export const MAX_CONTROL_ROWS = 2000;

const TEMPLATE_ROWS = [
  CSV_COLUMNS.join(','),
  'EX-001,Example control title,Short description,Access Control,Authentication,HIGH,https://example.com/doc',
  'EX-002,Another control,,,Logging,MEDIUM,',
];

export const downloadTemplate = () => {
  const blob = new Blob([TEMPLATE_ROWS.join('\n') + '\n'], {
    type: 'text/csv;charset=utf-8',
  });
  saveAs(blob, 'framework-controls-template.csv');
};

export const normalizeRow = (row) => {
  const cleaned = {};
  CSV_COLUMNS.forEach((col) => {
    const v = row[col];
    cleaned[col] = typeof v === 'string' ? v.trim() : v ?? '';
  });
  return cleaned;
};

/**
 * Validate parsed CSV rows client-side before POST.
 * Returns { controls, errors } — controls is the list of IngestControlInput
 * objects to submit, errors is an array of { row, message } for the preview.
 */
export const validateRows = (rawRows) => {
  const errors = [];
  const controls = [];
  const seenIds = new Set();

  if (rawRows.length === 0) {
    errors.push({ row: 0, message: 'CSV contains no rows.' });
    return { controls, errors };
  }

  if (rawRows.length > MAX_CONTROL_ROWS) {
    errors.push({
      row: 0,
      message: `Too many rows (${rawRows.length}). Max ${MAX_CONTROL_ROWS} per upload.`,
    });
    return { controls, errors };
  }

  rawRows.forEach((raw, idx) => {
    const row = normalizeRow(raw);
    const rowNum = idx + 2; // +1 for header, +1 for 1-indexed

    const missing = REQUIRED_COLUMNS.filter((c) => !row[c]);
    if (missing.length > 0) {
      errors.push({
        row: rowNum,
        message: `Missing required column(s): ${missing.join(', ')}`,
      });
      return;
    }

    if (seenIds.has(row.controlId)) {
      errors.push({
        row: rowNum,
        message: `Duplicate controlId: ${row.controlId}`,
      });
      return;
    }
    seenIds.add(row.controlId);

    const control = {
      controlId: row.controlId,
      title: row.title,
    };
    if (row.description) control.description = row.description;
    if (row.category) control.category = row.category;
    if (row.subcategory) control.subcategory = row.subcategory;
    if (row.priority) control.priority = row.priority;
    if (row.documentationUrl) control.documentationUrl = row.documentationUrl;
    controls.push(control);
  });

  return { controls, errors };
};
